import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {from, Observable} from 'rxjs';
import { AuthService } from "./services/global/auth.service";
import {DeliveryStorageService} from './services/storage/delivery-storage.service';
import {AuthStorageService} from './services/storage/auth-storage.service';
import {PlatformService} from "./services/core/platform.service";
import {ApiService} from "./services/global/api.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private storageService: AuthStorageService,
    private deliveryStorageService: DeliveryStorageService,
    private platformService: PlatformService,
    private apiService: ApiService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.setHeader(req, next));
  }

  async setHeader(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const [apiKey, storeId, employeeStoreId, deliveryType, isTerminal ] = await Promise.all([
      this.authService.getApiKey(),
      this.deliveryStorageService.getStoreId(),
      this.storageService.getEmployeeStoreId(),
      this.deliveryStorageService.getDeliveryType(),
      this.storageService.isTerminal()
    ]);
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      'api-version': this.platformService.getApiVersion()
    };
    if (apiKey) {
      headers['x-api-key'] = apiKey;
    }
    if (storeId) {
      headers['store-id'] = storeId;
    }
    if (employeeStoreId) {
      headers['employee-store-id'] = employeeStoreId;
    }
    if (deliveryType) {
      headers['delivery-type'] = deliveryType;
    }
    if (isTerminal) {
      headers['terminal-token'] = this.apiService.getTerminalKey();
    }
    req = req.clone({
      setHeaders: headers,
    });
    return next.handle(req).toPromise();
  }

}
